import React from 'react';
import SGHeadline from 'components/Typography/SGHeadline';
import styled from 'styled-components';
import Paper from 'components/Paper';
import Grid from '@material-ui/core/Grid';
import {mdiClose} from '@mdi/js';
import Icon from '@mdi/react';
import IconButton from '@material-ui/core/IconButton';
import FilterDropdown from './FilterDropDown';
import {FilterOptions} from './interfaces/FilterOptions';
import ClearFilters from './components/ClearFilters';

const StyledFiltersContainer = styled.div`
  min-height: 70px;
`;

const StyledPaper = styled(Paper)`
  border-radius: 0;
  border: 1px solid;
  border-color: ${props => props.theme.lightGrey};
`;

const StyledButton = styled(IconButton)`
  color: ${props => props.theme.text};
`;

const renderFilters = (
  selectedFilters: Record<string, string>,
  handleFilterChange: (filterKey: string, value: string) => void,
  filledFilterOptions: FilterOptions,
  isDisabled: boolean
) => {
  const filterKeys = Object.keys(filledFilterOptions);
  return filterKeys.map(filterKey => {
    let filterKeyValues = Object.keys(filledFilterOptions[filterKey].values);
    let selectedValues = selectedFilters[filterKey] ?? '';
    return (
      <Grid item key={filterKey}>
        <FilterDropdown
          isDisabled={isDisabled}
          filterKey={filterKey}
          label={filledFilterOptions[filterKey].label}
          selectedValue={selectedValues}
          options={filledFilterOptions[filterKey].values}
          handleFilterChange={handleFilterChange}
          filteredValueKeys={filterKeyValues}
        />
      </Grid>
    );
  });
};

interface FiltersTabProps {
  isOpen: boolean;
  selectedFilters: Record<string, string>;
  handleFilterChange: (filterKey: string, value: string) => void;
  filterFilledOptions: FilterOptions;
  handleFilterClear: () => void;
  handleButtonChange: () => void;
  isDisabled: boolean;
}

export default function FiltersTab({
  isOpen,
  selectedFilters,
  handleFilterChange,
  filterFilledOptions,
  handleFilterClear,
  handleButtonChange,
  isDisabled,
}: FiltersTabProps) {
  const isClearable = Object.keys(selectedFilters).length > 0;
  return (
    <StyledFiltersContainer>
      {isOpen && (
        <StyledPaper>
          <Grid container alignItems="center">
            <Grid item xs="auto">
              <SGHeadline variant={'h5'} className={'text-color'}>
                Filters
              </SGHeadline>
            </Grid>
            <Grid container item justify="center" alignItems="center" xs spacing={1}>
              {renderFilters(selectedFilters, handleFilterChange, filterFilledOptions, isDisabled)}
              {isClearable && (
                <Grid item>
                  <ClearFilters handleClearFilters={handleFilterClear} />
                </Grid>
              )}
            </Grid>
            <Grid item xs="auto">
              <StyledButton size="small" onClick={handleButtonChange}>
                <Icon path={mdiClose} size={1} />
              </StyledButton>
            </Grid>
          </Grid>
        </StyledPaper>
      )}
    </StyledFiltersContainer>
  );
}
